import { render, staticRenderFns } from "./jicaiDetail.vue?vue&type=template&id=4d927336&"
import script from "./jicaiDetail.vue?vue&type=script&lang=js&"
export * from "./jicaiDetail.vue?vue&type=script&lang=js&"
import style0 from "./jicaiDetail.vue?vue&type=style&index=0&id=4d927336&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports